import React, { useEffect, useState } from 'react';
import './modal-edicion-file.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faFile, faFilePdf, faSyncAlt, faTimes } from '@fortawesome/free-solid-svg-icons';
import { IconoPdf, IconoFileUnknow, IconoDocx } from 'assets/img';
import { IconButton } from '@mui/material';
import FileViewer from 'react-file-viewer';
function ModalEdicionFile(props) {
    const [ view, setView ] = useState(null);
    useEffect(() => {
        armarView(props.edicion);
    }, []);
    useEffect(() => {
        armarView(props.edicion);
    }, [props.edicion]);
    const onErrorViewer = (error) => {
        console.log(error);
    };
    const armarView = (edicion) => {
        const tipo = edicion && edicion.file && edicion.file.type ? edicion.file.type : null;
        let vw = null;
        switch (tipo) {
            case "image/jpg":
                vw = <img className="imagen-view" src={URL.createObjectURL(props.edicion.file)} alt="Thumb" />;
                break;
            case "image/jpeg":
                vw = <img className="imagen-view" src={URL.createObjectURL(props.edicion.file)} alt="Thumb" />;
                break;
            case "image/png":
                vw = <img className="imagen-view" src={URL.createObjectURL(props.edicion.file)} alt="Thumb" />;
                break;
            case "image/gif":
                vw = <img className="imagen-view" src={URL.createObjectURL(props.edicion.file)} alt="Thumb" />;
                break;
            case "application/pdf":
                vw = <iframe className="iframe-view" style={{ width: "100%", minHeight: 500 }} src={URL.createObjectURL(props.edicion.file)} />;
                break;
            case "application/docx":
                vw = <iframe className="iframe-view" style={{ width: "100%", minHeight: 500 }} src={URL.createObjectURL(props.edicion.file) + "&embedded=true"} />;
                break;
            case "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
                vw = <iframe className="iframe-view" style={{ width: "100%", minHeight: 500 }} src={URL.createObjectURL(props.edicion.file) + "&embedded=true"} />;
                break;
            default:
                vw = <img className="imagen-view" src={IconoFileUnknow} alt="Thumb" />;
                // vw = <FileViewer
                //     fileType={tipo.split("/")[1]}
                //     filePath={URL.createObjectURL(props.edicion.file)}
                //     errorComponent={<p>asdfasdf</p>}
                //     unsupportedComponent={<p>Archivo no soportado</p>}
                //     onError={onErrorViewer} />
                break;
        }
        setView(vw);
        // return <FileViewer
        //     fileType={tipo.split("/")[1]}
        //     filePath={URL.createObjectURL(props.edicion.file)}
        //     errorComponent={<p></p>}
        //     onError={onErrorViewer} />;
    }
    return (
        <>
            {props.show ? <div className="w3-modal w3-show modal-edicion-file">
                <div className="w3-modal-content w3-animate-zoom w3-round-large">
                    <div className="w3-row">
                        <div className="w3-col w3-right" style={{ width: '50px' }}>
                            <IconButton aria-label="delete" onClick={props.hide}>
                                &nbsp;<FontAwesomeIcon icon={faTimes} color={'#3A3A3A'} />&nbsp;
                            </IconButton>
                        </div>
                        <div className="w3-rest w3-padding w3-center">
                            <span>{props.edicion.label}</span>
                        </div>
                    </div>
                    <div className="w3-padding bs-bbox">
                        <div className="w3-block w3-padding bs-bbox">
                            <button className="w3-btn w3-light-gray w3-large w3-round-large w3-border w3-margin-right" onClick={props.hide}>
                                <FontAwesomeIcon icon={faTimes} color={'#000000'} /> Cerrar
                            </button>
                            <label htmlFor="upload-file" className="w3-btn w3-theme w3-large w3-round-large">
                                <FontAwesomeIcon icon={faSyncAlt} color={'#fff'} /> Cambiar
                            </label>
                            <input accept={props.acceptFiles} id="upload-file" name={props.edicion.documento} type="file" onChange={props.onChangeFile} style={{ display: 'none' }} />
                        </div>
                        <div className="w3-block w3-center view-container">
                            {view}
                        </div>
                    </div>
                </div>
            </div> : null}
        </>
    );
}
export default ModalEdicionFile;